// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "memories-" + chunkId + ".js?v=" + {"vendors-node_modules_webworker-typed_dist_index_js-node_modules_workbox-expiration_index_mjs":"53587fd825fb91a39492","components_frame_XImgWorker_ts":"6159334988e8e902f289"}[chunkId] + "";
};